import { Container, Typography, Box } from '@mui/material';

function Projects() {
  return (
    <Container>
      <Box sx={{ mt: 4 }}>
        <Typography variant="h3" gutterBottom>
          项目展示
        </Typography>
        <Typography variant="body1" paragraph>
          这里展示你的项目作品
        </Typography>
      </Box>
    </Container>
  );
}

export default Projects;